import React from 'react'
import {
  MenuItem as BootstrapMenuItem
} from 'react-bootstrap'
import classes from './MenuItem.module.scss'

const MenuItem: React.FC<any> = ({
  children,
  icon,
  ...restProps
}) => {
  return (
    <BootstrapMenuItem
      {...restProps}
    >
      {icon &&
        React.cloneElement(icon, {
          className: icon.props.className ? icon.props.className + ' ' + classes.icon : classes.icon
        })
      }
      {children}
    </BootstrapMenuItem>
  )
}

export default MenuItem
